import { Layout } from "antd";
import React from "react";
import MenuHeader from "./components/header";
import MenuFooter from "./components/footer";

const { Header, Content, Footer } = Layout;

const VerticalLayout = ({ children }) => {
  return (
    <Layout style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <Header style={{ backgroundColor: "#ffff", padding: 0 }}>
        <MenuHeader />
      </Header>

      <Content className="app-content">{children}</Content>

      <Footer className="app-footer" style={{ width: "100%" }}>
        <MenuFooter />
      </Footer>
    </Layout>
  );
};

export default VerticalLayout;
